import api from "./api";

let PAGES = {};
let GA = null;
let GSC = null;
const listeners = new Set();

export function getSeoOverride() {
  return PAGES;
}

export function getSeoConfig() {
  return { ga: GA, gsc: GSC };
}

export function subscribeSeo(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function loadSeoSettings() {
  try {
    const { data } = await api.get("/seo/settings");
    PAGES = data.pages || {};
    GA = data.ga_measurement_id || null;
    GSC = data.gsc_verification || null;
    listeners.forEach((f) => f());
  } catch {
    /* non-fatal */
  }
}
